export const manageDownloadDocument = (fileName, file, mimeType) => {
  const blob = new Blob([file], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
};
